const allowedContentTypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "audio/mpeg",
  "audio/wav",
  "audio/mp4",
  "video/mp4",
  "video/x-msvideo",
  "video/x-ms-wmv",
  "video/x-matroska",
  "video/webm",
  "video/3gpp",
  "video/3gpp2",
  "application/vnd.apple.mpegurl",
  "text/plain",
  "application/pdf",
  "application/msword",
  "application/xml",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "text/csv",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.ms-powerpoint",
];

const defaultallowedExtensions = [
  "webm",
  "mp3",
  "ppt",
  "docx",
  "pdf",
  "xlsx",
  "jpg",
  "jpeg",
  "png",
  "mp4",
];

const maxFileSize = 500 * 1024 * 1024; // 10 MB

const FileUploadComponent = (
  file,
  allowedExtensions = [...defaultallowedExtensions],
) => {
  let errorMessage = "";

  if (file) {
    const fileType = file.type;
    const fileName = file.name;
    const fileSize = file.size;
    const parts = fileName.split(".");
    const extension = parts.pop()?.toLowerCase();

    console.log(`extensionss`, extension);

    let fileExt = fileName.split(".");

    // Validate file type
    // if (!allowedExtensions.includes(extension)) {
    //   return "Invalid file extension";
    // }

    if (allowedExtensions !== null) {
      if (!allowedExtensions.includes(extension)) {
        return `Invalid file extension. Allowed: ${allowedExtensions
          .map((ext) => `.${ext}`)
          .join(", ")}`;
      }
    }

    if (!allowedContentTypes.includes(fileType.toLowerCase())) {
      errorMessage = "Invalid file type";
    }
    // Validate file size
    if (fileSize > maxFileSize) {
      errorMessage = "File size exceeds the limit";
    }

    // Validate Multiple File Extensions
    if (fileExt.length > 2) {
      errorMessage = "Multiple File Extension Not Allowed";
    }
  }

  return errorMessage;
};

export default FileUploadComponent;
